import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Button, Table, TableCell, TableRow } from 'telia-front-react';
import GaDataStore from '../../stores/GaDataStore';
import ProposalStore, { VolteRecommendation } from '../../stores/ProposalStore';
import RouteStore from '../../stores/RouteStore';
import { TranslationsContext } from '@teliaee/telia-translate';
import { VOLTE_RECOMMENDATIONS_CLICK_GA } from './ProposalsGaEvents';

interface VolteRecommendationsTableProps {
  proposalStore?: ProposalStore;
  routeStore?: RouteStore;
  perPage: number;
  currentPage: number;
}

@observer
class VolteProposalTable extends React.Component<VolteRecommendationsTableProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  private pushGa = (mobileRecommendation: VolteRecommendation) => {
    GaDataStore.pushWithoutCmsData(VOLTE_RECOMMENDATIONS_CLICK_GA, {
      deviceName: mobileRecommendation.deviceName,
    });
  };

  public render() {
    const translate = this.context.translate;
    const { proposalStore, currentPage, perPage } = this.props;
    return (
      <Table responsive={'cols'} break={'xl'}>
        <thead>
          <tr>
            <TableCell valign={'bottom'} type={'th'}>
              {translate('proposal.mobileRecommendations.modal.number')}
            </TableCell>
            <TableCell valign={'bottom'} type={'th'}>
              {translate('proposal.mobileRecommendations.modal.currentPhone')}
            </TableCell>
            <TableCell valign={'bottom'} type={'th'}>
              {translate('proposal.mobileRecommendations.modal.recommendation')}
            </TableCell>
            <TableCell valign={'bottom'} type={'th'} />
          </tr>
        </thead>
        <tbody>
          {proposalStore.filteredRecommendations.volteRecommendations
            .slice((currentPage - 1) * perPage, (currentPage - 1) * perPage + perPage)
            .map((r, idx) => {
              return (
                <TableRow key={`device-${idx}`}>
                  <TableCell width={2}>{r.mobileNumber}</TableCell>
                  <TableCell width={3}>{r.deviceName}</TableCell>
                  <TableCell width={4}>{translate('proposal.volteRecommendations.modal.recommendation.text')}</TableCell>
                  <TableCell width={2} headless={true}>
                    <Button
                      text={translate('proposal.mobileRecommendations.modal.viewMore')}
                      link={true}
                      iconRight={'#arrow-right'}
                      url={r.redirectUrl}
                      target={'_blank'}
                      onClick={() => this.pushGa(r)}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
        </tbody>
      </Table>
    );
  }
}

export default inject('proposalStore', 'routeStore')(VolteProposalTable);
